import React from 'react';
import { JournalEntry } from '../../../types';

interface Props {
  entries: JournalEntry[];
  onEdit: (e: JournalEntry) => void;
  onDelete: (id: number) => void;
}

export function JournalEntryList({ entries, onEdit, onDelete }: Props) {
  if (!entries.length) return (
    <div className="empty"><div className="icon">📓</div><h3>No Entries</h3><p>Log your first trade to begin building your playbook.</p></div>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 480, overflowY: 'auto' }}>
      {entries.map(e => {
        const isWin = e.outcome === 'win', isLoss = e.outcome === 'loss';
        const bColor = isWin ? 'var(--green)' : isLoss ? 'var(--red)' : 'var(--b1)';
        return (
          <div key={e.id} className="card-inner" style={{ borderLeft: `2px solid ${bColor}` }}>
            <div className="fsb mb4">
              <div className="flex gap8">
                <span className="mono" style={{ fontSize: 11, color: 'var(--t2)' }}>{e.date}</span>
                <span style={{ fontSize: 14, fontWeight: 700, color: 'var(--t0)' }}>{e.symbol}</span>
                <span style={{ fontSize: 13, color: 'var(--t1)' }}>{e.setup}</span>
                {e.regime && <span className="badge b-dim" style={{ fontSize: 10 }}>{e.regime}</span>}
                {e.dir && <span className={`badge ${e.dir === 'long' ? 'b-green' : 'b-red'}`} style={{ fontSize: 10 }}>{e.dir}</span>}
              </div>
              <div className="flex gap6">
                {e.result !== null && (
                  <span className="mono" style={{ fontSize: 14, fontWeight: 700, color: isWin ? 'var(--green)' : 'var(--red)' }}>
                    {isWin ? '+' : ''}${Number(e.result).toFixed(2)}
                  </span>
                )}
                {e.rMultiple !== null && (
                  <span className="mono" style={{ fontSize: 12, color: isWin ? 'var(--green)' : 'var(--red)' }}>{e.rMultiple > 0 ? '+' : ''}{e.rMultiple}R</span>
                )}
                <button className="btn btn-sm btn-icon" onClick={() => onEdit(e)} title="Edit">✏</button>
                <button className="btn btn-sm btn-icon btn-danger" onClick={() => { if (window.confirm('Delete this entry?')) onDelete(e.id); }}>✕</button>
              </div>
            </div>
            {(e.entry || e.stop || e.target || e.exit) && (
              <div className="flex gap10 mb4 mono" style={{ fontSize: 12, color: 'var(--t2)' }}>
                {e.entry && <span>E:<span style={{ color: 'var(--t1)' }}>{e.entry}</span></span>}
                {e.stop && <span>S:<span style={{ color: 'var(--red)' }}>{e.stop}</span></span>}
                {e.target && <span>T:<span style={{ color: 'var(--green)' }}>{e.target}</span></span>}
                {e.exit && <span>X:<span style={{ color: isWin ? 'var(--green)' : 'var(--red)' }}>{e.exit}</span></span>}
              </div>
            )}
            {e.tags?.length > 0 && (
              <div className="flex gap4 mb4" style={{ flexWrap: 'wrap' }}>
                {e.tags.map(t => <span key={t} className="badge b-dim" style={{ fontSize: 10 }}>{t}</span>)}
              </div>
            )}
            {e.notes && <div style={{ fontSize: 12, color: 'var(--t2)', lineHeight: 1.5 }}>{e.notes}</div>}
          </div>
        );
      })}
    </div>
  );
}
